/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IUser } from 'app/shared/model/user.model';
import { IContactDetails } from 'app/shared/model/contact-details.model';
import { LabServiceType } from 'app/shared/model/enumerations/lab-service-type.model';

export interface IDiagLab {
  id?: string;
  name?: string;
  createdDtm?: number;
  createdBy?: string;
  timestampEntry?: number;
  microSec?: number;
  lastUpdated?: number;
  active?: boolean;
  cursor?: number;
  email?: string;
  taxCode?: string | null;
  billPrefix?: string | null;
  ownPanels?: boolean;
  labServiceType?: keyof typeof LabServiceType | null;
  description?: string | null;
  user?: IUser;
  contactCode?: IContactDetails;
}

export const defaultValue: Readonly<IDiagLab> = {
  active: false,
  ownPanels: false,
};
